/** Friendly no-plans state shows only for a resolved-empty list — never mid-load. */
export const shouldShowNoPlans = (
  plansLoading: boolean,
  plansError: string | null,
  planCount: number,
): boolean => !plansLoading && !plansError && planCount === 0;
